import { render } from "./home.vue?vue&type=template&id=4c26ae5d"
const script = {}
script.render = render

export default script